
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component } from "vue-property-decorator";
import { sourceTypeEnum } from "@/service/supplier-meta/enums/sourceTypeEnum";
import { Enum } from "@/service/supplier-meta/entity/Enum";
import { getEnum, getNewProductCategory } from "@/service/supplier-meta/api";
import { supplyTypeEnum } from "@/service/supplier-meta/enums/supplyTypeEnum";
import { supplyClassificationEnum } from "@/service/supplier-meta/enums/supplyClassificationEnum";
import { SelectOption } from "@/service/common/entity/SelectOption";
import { enumToOption } from "@/utils";
import { resolveEnum } from "@/utils/resolveEnum";
import { ElementUiTreeNode } from "@/service/common/entity/ElementUiTreeNode";
import { ResNewProductCategoryDTO } from "@/service/supplier-meta/entity/ResNewProductCategoryDTO";
import { NewProductCategoryOption } from "@/service/supplier-meta/entity/NewProductCategoryOption";
import { genCacheMixin } from "../../common/cache.mixin";
import {
  isClothingCategory,
  clothingCategoryId,
  fillCategoryOptions,
} from "@/service/supplier-meta/common/supplier-info-service";
import { StepForm } from "../../common/StepForm";
import { Form } from "element-ui";
import { SupplierInfoSubmitBO } from "@/service/supplier-meta/entity/SupplierInfoSubmitBO";
import { CascaderNode } from "element-ui/types/cascader-panel";
const defaultSourceType = -1;
@Component({
  components: {},
  mixins: [
    genCacheMixin({
      field: "form",
      saveKey: "SupplierAttr",
      readyField: "ready",
      useCache: (ctx: SupplierAttr) =>
        !(ctx.data && typeof ctx.data === "object"),
      cacheRecovered(ctx: SupplierAttr) {
        ctx.$emit("formChange", ctx.getFormData());
        // category缓存的是id路径
        const rootCategoryId = ctx.form.category[0];
        // el-cascader对自动设置的值不会触发change事件，因此需手动判断是否是服装品类并进行同步
        ctx.$emit(
          "update:isClothingCategory",
          isClothingCategory(rootCategoryId)
        );
      },
    }),
  ],
})
export default class SupplierAttr extends StepForm {
  form = {
    sourceType: defaultSourceType,
    category: [] as string[],
    categoryName: "",
    supplyType: null as number | null,
    supplyClassification: null as number | null,
  };
  categoryData: NewProductCategoryOption[] = [];
  supplyClassificationEnums: Enum[] = [];
  supplyTypeEnums: Enum[] = [];
  ready = true;
  catagoryCascaderPanelProps = {
    label: "cn_name",
    value: "id",
    children: "children",
    checkStrictly: true,
    expandTrigger: "hover",
    lazy: true,
    async lazyLoad(
      node: CascaderNode<Node, NewProductCategoryOption>,
      resolve: (data: NewProductCategoryOption[]) => void
    ) {
      //
      if (node.children?.length) {
        resolve([]);
        return;
      }
      const id = node.data?.id;
      if (!id) {
        return;
      }
      const res = await getNewProductCategory(id);
      if (res.is_success && Array.isArray(res.result)) {
        resolve(res.result);
      } else {
        resolve([]);
      }
    },
  };
  types = [
    {
      label: "现货供应商",
      desc: "可提供现货（网拍/线下实体/工厂）",
      value: sourceTypeEnum.oa,
    },
    {
      label: "服装代加工工厂",
      desc: "供应商提供纯代加工模式，棒谷自主设计、生产",
      value: sourceTypeEnum.pmc_factory,
    },
    {
      label: "服装面辅料供应商",
      desc: "提供面料/辅料/耗材等原材料",
      value: sourceTypeEnum.pmc_supplier,
    },
  ];
  get matchedCategoryOptions() {
    return this.getResolvedCategoryOptions(this.categoryData);
  }
  get supplyClassificationOptions() {
    return enumToOption(
      resolveEnum(
        "SupplyClassificationEnum",
        this.supplyClassificationEnums,
        this.form.sourceType
      )
    );
  }
  get matchedSupplyTypeOptions(): SelectOption[] {
    const options = enumToOption(this.supplyTypeEnums);
    if (this.isClothingCategory && this.form.sourceType === sourceTypeEnum.oa) {
      return options.filter((opt) => opt.value !== supplyTypeEnum.IPD);
    }
    return options;
  }
  get rules(): { [x: string]: any[] } {
    return {
      category: this.getFieldRules("enterpriseInfo.categoryId"),
      supplyClassification: this.getFieldRules(
        "factoryInfo.supplyClassification"
      ),
      supplyType: this.getFieldRules("enterpriseInfo.supplyType"),
    };
  }
  get categoryDisabled() {
    return this.form.sourceType === sourceTypeEnum.pmc_supplier;
  }
  get supplyClassificationDisabled(): boolean {
    return [sourceTypeEnum.pmc_factory, sourceTypeEnum.oa].includes(
      this.form.sourceType
    );
  }
  get supplyTypeDisabled(): boolean {
    return [sourceTypeEnum.pmc_factory].includes(this.form.sourceType);
  }
  async created() {
    if (this.form.sourceType === defaultSourceType) {
      this.selectType(sourceTypeEnum.oa);
    }
    this.categoryData = await this.getCategoryData();
    // 品类回显
    const idPaths = this.form.category;
    fillCategoryOptions(idPaths, this.categoryData);
    if (this.data && typeof this.data === "object") {
      this.setFormData(this.data);
    }
    setTimeout(() => {
      this.ready = true;
    });
    this.getOptions();
  }
  setFormData(data: SupplierInfoSubmitBO) {
    this.form.sourceType = data.sourceTypeCode;
    this.form.supplyType = data.enterpriseInfo?.supplyType;
    this.form.supplyClassification =
      data.factoryInfo?.supplyClassification || null;
    const supplierCategoryId = data.enterpriseInfo?.categoryId;
    if (!Number.isNaN(+supplierCategoryId)) {
      this.form.category = []; // this.getCategoryByLeafNodeVal(supplierCategoryId);
      const rootCategoryId = this.form.category[0];
      // el-cascader对自动设置的值不会触发change事件，因此需手动判断是否是服装品类并进行同步
      this.$emit(
        "update:isClothingCategory",
        isClothingCategory(rootCategoryId)
      );
    }
  }

  selectType(type: number) {
    if (!this.ready) {
      return;
    }
    this.ready = false;
    console.log("type:", type);
    this.form.sourceType = type;
    this.handleSourceTypeChange();
    setTimeout(() => {
      this.ready = true;
    });
  }
  handleSourceTypeChange() {
    this.form.category = [];
    this.form.supplyClassification = null;
    this.form.supplyType = null;
    this.setDefaultValues();
  }
  setDefaultValues() {
    switch (this.form.sourceType) {
      case sourceTypeEnum.oa: //oa供应商
        this.$emit("update:isClothingCategory", false);
        this.form.supplyClassification = supplyClassificationEnum.成衣;
        break;
      case sourceTypeEnum.pmc_supplier: //面辅料供应商
        this.form.category = [clothingCategoryId + ""];
        this.$emit("update:isClothingCategory", true);
        break;
      case sourceTypeEnum.pmc_factory: //工厂供应商
        this.form.category = [clothingCategoryId + ""];
        this.$emit("update:isClothingCategory", true);
        this.form.supplyClassification = supplyClassificationEnum.成衣;
        this.form.supplyType = supplyTypeEnum.IPD;
        break;
    }
    setTimeout(() => {
      this.handleCategoryChange();
      const form = this.$refs.form as Form;
      form?.clearValidate("supplyType");
      form?.clearValidate("supplyClassification");
    });
  }
  async getOptions(): Promise<void> {
    getEnum("SupplyClassificationEnum", true).then((res) => {
      if (res.isSuccess && Array.isArray(res.result)) {
        this.supplyClassificationEnums = res.result;
      }
    });
    getEnum("SupplyTypeEnum", true).then((res) => {
      if (res.isSuccess && Array.isArray(res.result)) {
        this.supplyTypeEnums = res.result;
      }
    });
  }
  getResolvedCategoryOptions(
    data: ResNewProductCategoryDTO[]
  ): ResNewProductCategoryDTO[] {
    // 面辅料供应商工厂供应商只能选择服装
    if (
      this.form.sourceType === sourceTypeEnum.pmc_supplier ||
      this.form.sourceType === sourceTypeEnum.pmc_factory
    ) {
      return data.filter((ele) => isClothingCategory(ele.id));
    }
    return data;
  }
  async getCategoryData(): Promise<ResNewProductCategoryDTO[]> {
    const res = await getNewProductCategory();
    if (res.is_success && res.result) {
      return res.result;
    }
    return [];
  }
  handleCategoryChange(): void {
    const checkedCategoryNodes = (
      this.$refs.categoryCascader as any
    )?.getCheckedNodes();
    const category: ElementUiTreeNode<NewProductCategoryOption> =
      checkedCategoryNodes ? checkedCategoryNodes[0] : null;
    if (category) {
      this.form.categoryName = category.pathLabels.join("/");
    }
    const isClothing =
      category && category.path.some((id) => isClothingCategory(id as string));
    if (isClothing !== this.isClothingCategory) {
      this.resetSupplyType();
    }
    this.$emit("update:isClothingCategory", !!isClothing);
  }

  resetSupplyType() {
    this.form.supplyType = null;
  }
  async validate() {
    const form = this.$refs.form as Form;
    if (this.form.sourceType === defaultSourceType) {
      this.$message.warning("请选择店铺类型！");
      return false;
    }
    return form.validate();
  }
  getFormData() {
    const categoryPathArr = this.form.category;
    const checkedCategoryNodes = (
      this.$refs.categoryCascader as any
    )?.getCheckedNodes();
    const category: ElementUiTreeNode<NewProductCategoryOption> =
      checkedCategoryNodes ? checkedCategoryNodes[0] : null;
    return {
      sourceTypeCode: this.form.sourceType,
      enterpriseInfo: {
        categoryId:
          category?.value || categoryPathArr[categoryPathArr.length - 1],
        categoryPathName:
          category?.data?.full_cn_name || this.form.categoryName,
        supplyType: this.form.supplyType,
      },
      factoryInfo: {
        supplyClassification: this.form.supplyClassification,
      },
    };
  }
}
